OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Classes.Marquee = new Class({
    Implements: [Options, Events],
    api_url: '/index.php/api/weather_briefing/get_okfirst_ticker/format/json',
    mode: 'normal',
    item: null,
    item_created: false,
    started: false,
    marquee_text: '',
    ticker_text: '',
    ticker_text_retrieved: 0,
    displayed_adv_keys: {},
    active_notices: {},
    events: {},
    options: {
        'ticker_retrieval_rate': 1000 * 60 * 60 * 5,
        'warning_mode': 'warning',
        'watch_mode': 'watch',
        'normal_mode': 'normal',
        'container_id': 'marquee',
        'container_selector': '#marquee',
        'container_data_name': 'marquee',
        run_marquee_ops: {
            duration: 20000,
            direction: 'left',
            duplicated: false,
            pauseOnHover: true
        }
    },
    initialize: function (element, ops) {
        var data_name, container_id;
        if (!element) {
            if (ops && ops.hasOwnProperty('container_id')) {
                container_id = ops.container_id;
            } else {
                container_id = this.options.container_id;
            }
            element = document.id(container_id);
        }
        if (element) {
            this.item = element;
            if (ops && ops.hasOwnProperty('container_data_name')) {
                data_name = ops.container_data_name;
            } else {
                data_name = this.options.container_data_name;
            }
            var current_obj = element.retrieve(data_name);
            if (current_obj) {
                if (ops) {
                    current_obj.setOptions(ops);
                }
                return current_obj;
            }
        } else {
            this.item_created = true;
            this.item = new Element('div', {id: container_id});
            this.item.inject(document.body);
        }
        this.setOptions(ops);
        this.init_ajax();
        this.fetch_ticker();
        if (this.item) {
            this.item.store(data_name, this);
        }


    },
    fetch_ticker: function () {
        if (this.mode != this.options.warning_mode && this.mode != this.options.watch_mode) {
            if (!this.ticker_text_retrieved) {
                this.fetch_ticker_method();
            } else {
                var dateClass = OCS.Functions.define_OCSDateTime();
                var dateObj = new dateClass();
                this.marquee_text += this.ticker_text;
                if ((this.ticker_text_retrieved + this.options.ticker_retrieval_rate) < dateObj.get_server_epoch_time()) {
                    this.ticker_text_retrieved = 0;
                    this.ticker_text = '';
                }
            }
        }
        this.displayed_adv_keys = {};
        if (Object.keys(this.active_notices).length) {
            Object.each(this.active_notices, function (notice, key) {
                if (!this.displayed_adv_keys.hasOwnProperty((notice.adv_key))) {
                    this.displayed_adv_keys[notice.adv_key] = true;
                    this.marquee_text += ' \xa0 ' + this.get_notice_title(notice);
                    for (var i = 0; i < 100; i++) {
                        this.marquee_text += ' \xa0\xa0';
                    }
                }
            }.bind(this));
        }
        if (this.marquee_text !== '') {
            this.run();
        }
    },
    rerun: function () {
        this.marquee_text = '';
        this.item.empty();
        jQuery(this.item).marquee('destroy');
        this.fetch_ticker();
        this.started = false;
        this.run();
    },
    run: function () {
        if (this.marquee_text && !this.started) {
            this.item.appendHTML(this.marquee_text, 'top');
            jQuery(this.item).marquee(this.options.run_marquee_ops);
            this.started = true;
        }
    },
    init_ajax: function () {
        var am = OCS.Functions.get_ajax_manager();
        var req = am.request("fetch_ticker", {
            url: this.api_url,
            dataType: "json",
            method: "GET",
            onSuccess: this.on_fetch_ticker_success.bind(this)
        });
        this.fetch_ticker_method = OCS.Utilities.create_throttled_method(function () {
            am.request("fetch_ticker").send();
        }, 60000);
    },
    on_fetch_ticker_success: function (response) {
        var dateObj = OCS.Functions.get_OCSDateTime();
        var data = response.json;
        this.ticker_text = '';
        if (data && data.success && data.ticker && data.ticker.length) {
            Object.each(data.ticker, function (item) {
                if (item.story) {
                    this.ticker_text += ' \xa0\xa0\xa0\xa0 ' + item.story;
                }
            }.bind(this));
        }
        // if (location.hostname === "beta.mesonet.org" || location.hostname === "xbeta.mesonet.org" || location.hostname === "xwww.mesonet.local") {
        //     this.ticker_text += ' \xa0\xa0\xa0\xa0 ' + '***** Welcome to the Beta Test Site! Please do not bookmark! To submit an error go to <a href="http://www.surveymonkey.com/s/ok1beta" target="_blank"> www.surveymonkey.com/s/ok1beta</a>*****\xa0\xa0\xa0\xa0\xa0';
        // }
        if (data && data.expiration) {
            this.ticker_text += ' \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 ' + (data.expiration);
        }
        this.marquee_text += this.ticker_text;
        this.ticker_text_retrieved = dateObj.get_server_epoch_time();
        this.run();
    },

    get_notice_title: function (notice) {
        return '' + notice.name + ' in effect for ' + notice.affected_area.join(', ') + ' until ' + notice.time_string + '. ';
    },
    set_mode: function (mode) {
        if (mode != this.mode) {
            switch (mode) {
                case this.options.warning_mode:
                    this.mode = this.options.warning_mode;
                    break;
                case this.options.watch_mode:
                    this.mode = this.options.watch_mode;
                    break;
                default:
                    this.mode = this.options.normal_mode;
                    break;
            }
            this.fetch_ticker();
        }
    },
    set_active_notices: function (notices) {
        this.active_notices = notices;
        this.rerun();
    },
    destroy: function () {
        console.log("OCS.WxBriefing.Classes.marquee: Destroying!");
        this.removeEvents();
        if (this.item) {
            jQuery(this.item).marquee('destroy');
            this.item.store(this.options.container_data_name, null);
            this.item.empty();
            if(this.item_created) {
                this.item.destroy();
            }
            this.item = null;
        }
        this.started = false;
    }
});